export default __webpack_public_path__ + "static/media/Hephestus_Desktop.fe90d015.mp4";